import Welcome from './Welcome';
import Route from './route';

export default {
  RenderProp: Welcome,
  mainRoute: Route,
};
